<template>
  <v-container fluid class="main-container">
    <UniversalTable
      :config="tableConfig.tableParams.value"
      :items="filteredPositions"
      :items-count="positions.getPositionsCount()"
      backend-pagination
      @onSearch="viewState.handleSearch"
      @onClick="viewState.state.filters.showFilterDialog = true"
      @removeFilter="viewState.removeFilters"
      @removeAllFilters="viewState.clearFilters"
      :emptyObjectData="emptyObjectData"
      @onActionClick="viewState.recalculateAllEmployees"
      @onSort="viewState.handleSort"
      @onRequest="handlePaginationRequest"
      :loading="$loader.isAppLoading"
    >
    </UniversalTable>
    <SearchModal
      :dialog="viewState.state.filters.showFilterDialog"
      @back="viewState.state.filters.showFilterDialog = false"
      @checkedItemsChanged="viewState.applyFilters"
      :clearSelection="viewState.state.filters.clearSelection"
      filterType="Employee Readiness"
      :filterGroups="viewState.state.filters.filterGroups"
      :statusOptions="[]"
      :modalWidth="800"
      :defaultSelected="viewState.state.filters.values"
    />
    <ChecklistDrawer
      ref="drawerContainer"
      :type="'Position'"
      :drawer="
        viewState.state && viewState.state.openChatterModal && viewState.state.openChatterModal.show
      "
      :typeValue="(positions.getCurrentPosition() && positions.getCurrentPosition().name) || ''"
      object-type="position"
      :object-id="viewState.state?.openChatterModal?.positionId ?? null"
      @closeDrawer="viewState.closePositionChatterModal()"
      :chatterList="
        viewState.state &&
        viewState.state.openChatterModal &&
        viewState.state.openChatterModal.chatterData
      "
      :totalCheckpointChatter="
        viewState.state &&
        viewState.state.openChatterModal &&
        viewState.state.openChatterModal.totalPositionChatter
      "
      iconName="org_icon_position"
      @requestMoreCheckpointsChatter="viewState.requestMoreChatter()"
    />
  </v-container>
</template>

<script setup>
import { computed, onMounted, getCurrentInstance } from "vue";
import { usePositions } from "@/composables/positions/usePositions";
import { useReadinessOrganization } from "@/composables/readinessOrganization/useReadinessOrganization";
import UniversalTable from "@components/UniversalTable/UniversalTable.vue";
import { useTableConfig } from "./composables/useTableConfig";
import { useViewState } from "./composables/useViewState";
import SearchModal from "@components/SearchBar/SearchModal.vue";
import ChecklistDrawer from "@components/Drawer/ChatterDrawer.vue";

const app = getCurrentInstance();
const { proxy } = app || {};
const tableConfig = useTableConfig();
const viewState = useViewState();
const position = useReadinessOrganization();
const positions = usePositions();
const emptyObjectData = {
  singular: "Readiness Organization",
  plural: "Readiness Organizations",
};

const filteredPositions = computed(() => {
  let allPositions = position.allPositions.value;

  // if (viewState.state.filters.searchText?.trim()) {
  //   const searchText = viewState.state.filters.searchText.toLowerCase();
  //   allPositions = allPositions.filter((position) => {
  //     return (
  //       position.name.toLowerCase().includes(searchText) ||
  //       position.code_str?.toString().includes(searchText)
  //     );
  //   });
  // }

  // allPositions = allPositions.sort((a, b) => {
  //   const firstNameA = a?.name?.toLowerCase() || "";
  //   const firstNameB = b?.name?.toLowerCase() || "";
  //   const lastNameA = a?.name?.toLowerCase() || "";
  //   const lastNameB = b?.name?.toLowerCase() || "";

  //   if (firstNameA < firstNameB) return -1;
  //   if (firstNameA > firstNameB) return 1;

  //   if (lastNameA < lastNameB) return -1;
  //   if (lastNameA > lastNameB) return 1;

  //   return 0;
  // });
  return allPositions;
});
// Handle pagination requests from UniversalTable
const handlePaginationRequest = async (paginationData) => {
  try {
    proxy.$loader.show();
    // Update pagination state first
    viewState.state.table.currentPage = paginationData.page;
    viewState.state.table.itemsPerPage = paginationData.itemsPerPage;
    // Load employees with current filters to preserve query parameters
    await viewState.loadPositionsWithFilters();
  } finally {
    proxy.$loader.hide();
  }
};
onMounted(async () => {
  try {
    proxy.$loader.show();
    // Initialize view state (resets pagination)
    viewState.initializeViewState();
    await viewState.loadPositionsWithFilters();
  } finally {
    proxy.$loader.hide();
  }
});
</script>

<style scoped>
.main-container {
  padding-bottom: 80px !important;
}
.icon-container {
  cursor: pointer;
}
</style>
